import React from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import { LegalPage } from './LegalPage';
import { COOKIES } from './legal-content';
import { CookieSettingsLink } from '../../components/CookieBanner';

export default function CookiePolicy() {
    return (
        <LegalPage
            icon={Cookie}
            content={COOKIES}
            extraFooter={
                <>
                    <CookieSettingsLink className="text-[hsl(var(--accent))] underline" />
                    {' · '}
                    <Link to="/privacy" className="text-[hsl(var(--accent))] underline">Privacy Policy</Link>
                    {' · '}
                    <Link to="/terms" className="text-[hsl(var(--accent))] underline">Terms</Link>
                </>
            }
        />
    );
}
